'use client';

import { ChevronDown } from 'lucide-react';
import styles from './HeroBanner.module.scss';

export type ScrollToContentButtonProps = {
  scrollToContentId?: string;
};

const ScrollToContentButton: React.FC<ScrollToContentButtonProps> = ({ scrollToContentId }) => {
  const scrollToContent = () => {
    if (!scrollToContentId) return;
    document.getElementById(scrollToContentId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button
      className={styles.viewMore}
      style={{ color: 'var(--dark)', marginBottom: '2em' }}
      onClick={scrollToContent}
    >
      <ChevronDown size={36} />
    </button>
  );
};

export default ScrollToContentButton;
